module.exports = "/_next/static/images/Frame@2x-c7615e68f8d72b7ff8163e04cae4deee.png";